import React, { useState, useRef, useEffect } from "react";
import HotspotPoint from "../HotspotPoint";
import baseMapImage from "../images/base.png";
import "./style.scss";

const MapView = ({ hotspots }) => {
  const [mapDimensions, setMapDimensions] = useState({ width: 0, height: 0 });
  const mapRef = useRef(null);

  useEffect(() => {
    const updateMapDimensions = () => {
      if (mapRef.current) {
        const img = mapRef.current.querySelector("img");
        if (img && img.complete) {
          // Use actual image dimensions for more accurate positioning
          setMapDimensions({
            width: img.offsetWidth,
            height: img.offsetHeight,
          });
        } else {
          // Fallback to container dimensions
          const rect = mapRef.current.getBoundingClientRect();
          setMapDimensions({
            width: rect.width,
            height: rect.height,
          });
        }
      }
    };

    // Debounced resize handler
    let resizeTimeout;
    const debouncedResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateMapDimensions, 100);
    };

    // Initial update
    updateMapDimensions();

    // Update on resize with debounce
    window.addEventListener("resize", debouncedResize);

    // Update when image loads
    const img = mapRef.current?.querySelector("img");
    if (img) {
      img.addEventListener("load", updateMapDimensions);
    }

    return () => {
      window.removeEventListener("resize", debouncedResize);
      clearTimeout(resizeTimeout);
      if (img) {
        img.removeEventListener("load", updateMapDimensions);
      }
    };
  }, []);

  // Update dimensions when hotspots change (different map)
  useEffect(() => {
    const updateMapDimensions = () => {
      if (mapRef.current) {
        const img = mapRef.current.querySelector("img");
        if (img && img.complete) {
          // Use actual image dimensions for more accurate positioning
          setMapDimensions({
            width: img.offsetWidth,
            height: img.offsetHeight,
          });
        } else {
          // Fallback to container dimensions
          const rect = mapRef.current.getBoundingClientRect();
          setMapDimensions({
            width: rect.width,
            height: rect.height,
          });
        }
      }
    };

    // Small delay to ensure DOM is updated
    const timer = setTimeout(updateMapDimensions, 100);
    return () => clearTimeout(timer);
  }, [hotspots]);

  return (
    <div className="map-container">
      <div className="interactive-map-wrapper" ref={mapRef}>
        <img src={baseMapImage} alt="Map" />

        {hotspots.map((hotspot) => {
          return (
            <HotspotPoint
              key={hotspot.id}
              id={hotspot.id}
              x={hotspot.x}
              y={hotspot.y}
              title={hotspot.title}
              image={hotspot.image}
              mapWidth={mapDimensions.width}
              mapHeight={mapDimensions.height}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MapView;
